import * as React from "react";

import { MyPlan } from "../../../components";

export const MyPlanContainer: React.FC = () => <MyPlan />;
